(function () {
    'use strict';

    angular
        .module('app')
        .controller('GroupsAddController', GroupsAddController);

    GroupsAddController.$inject = ['$stateParams','$scope', '$state', 'API', 'i18n',];

    function GroupsAddController($stateParams, $scope, $state, API, i18n) {
        $scope.$state = $state;
        var vm = this;
        vm.isAdding = false;
        vm.add = add;
        vm.group = {
            fk_school_id: $stateParams.schoolId
        };
        vm.groupTeachers = [];

        function add() {
            if (!vm.isAdding) {
                vm.isAdding = true;

                var newGroup = new API.Group(vm.group);

                var promise = newGroup.$save();

                promise.then(function (response) {
                    window.toast({ message: i18n.get('SAVED'), autoRemoveTime: 5000, type: 'success' });
                    $state.go('groups.edit', { id: response.id });
                }, function () {
                })
                .finally(function() {
                    vm.isAdding = false;
                });
            }
        }
    }
})();